import React, { FC, CSSProperties } from 'react';

const productContainerStyle: CSSProperties = {
  color: '#fff',
  background: '#a32563',
  margin: '-50px -30px 30px -30px',
  fontSize: '14px',
};

const checkoutAmountStyle: CSSProperties = {
  backgroundColor: 'rgba(255,255,255,.3)',
  padding: '15px 20px',
  fontWeight: 'bold',
  fontSize: '18px',
  textAlign: 'center',
  textTransform: 'uppercase',
};

const productDetailsStyle: CSSProperties = {
  padding: '20px',
  display: 'flex',
  alignItems: 'center',
  lineHeight: 1.3,
};

const Header: FC<{
  image: string;
  amount: string;
  description: string;
  title: string;
}> = ({ image, amount, description, title }) => {
  return (
    <div style={productContainerStyle}>
      <p style={checkoutAmountStyle}>Valor da compra: R$ {amount}</p>
      <div style={productDetailsStyle}>
        <img width={64} style={{ marginRight: '10px' }} src={image} alt="" />
        <div>
          <b>{title}</b>
          <p style={{ marginTop: '5px', fontSize: '14px' }}>{description}</p>
        </div>
      </div>
    </div>
  );
};

export default Header;
